<div class="flex w-screen h-full bg-gradient justify-center">
    <div class="flex flex-col items-center h-auto w-auto text-white my-auto">
        <h1 class="text-huge">403</h1>
        <h2 i18n="@@noAccess">Geen toegang</h2>
        <h2 i18n="@@utilities.redirectHome">Klik <a class="underline text-white" href="/">hier</a> om terug te keren</h2>
    </div>
</div>
